"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManualManager = void 0;
const dynamicLoadManager_1 = require("../../dynamicLoadManager");
class DynamicLoadManualManager extends dynamicLoadManager_1.DynamicLoadManagerBase {
}
exports.DynamicLoadManualManager = DynamicLoadManualManager;
//# sourceMappingURL=manager.js.map